import _createForOfIteratorHelper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module clipboard/pasteplaintext
 */
import { Plugin } from '@ckeditor/ckeditor5-core';
import ClipboardObserver from './clipboardobserver.js';
import ClipboardPipeline from './clipboardpipeline.js';
/**
 * The plugin detects the user's intention to paste plain text.
 *
 * For example, it detects the <kbd>Ctrl/Cmd</kbd> + <kbd>Shift</kbd> + <kbd>V</kbd> keystroke.
 */
var PastePlainText = /*#__PURE__*/function (_Plugin) {
  _inherits(PastePlainText, _Plugin);
  var _super = _createSuper(PastePlainText);
  function PastePlainText() {
    _classCallCheck(this, PastePlainText);
    return _super.apply(this, arguments);
  }
  _createClass(PastePlainText, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var editor = this.editor;
      var model = editor.model;
      var view = editor.editing.view;
      var viewDocument = view.document;
      var selection = model.document.selection;
      var shiftPressed = false;
      view.addObserver(ClipboardObserver);
      this.listenTo(viewDocument, 'keydown', function (evt, data) {
        shiftPressed = data.shiftKey;
      });
      editor.plugins.get(ClipboardPipeline).on('contentInsertion', function (evt, data) {
        // Plain text can be determined based on the event flag (#7799) or auto-detection (#1006). If detected,
        // preserve selection attributes on pasted items.
        if (!shiftPressed && !isPlainTextFragment(data.content, model.schema)) {
          return;
        }
        model.change(function (writer) {
          // Formatting attributes should be preserved.
          var textAttributes = Array.from(selection.getAttributes()).filter(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 1),
              key = _ref2[0];
            return model.schema.getAttributeProperties(key).isFormatting;
          });
          if (!selection.isCollapsed) {
            model.deleteContent(selection, {
              doNotAutoparagraph: true
            });
          }
          // Also preserve other attributes if they survived the content deletion (because they were not fully selected).
          // For example linkHref is not a formatting attribute but it should be preserved if pasted text was in the middle
          // of a link.
          textAttributes.push.apply(textAttributes, _toConsumableArray(selection.getAttributes()));
          var range = writer.createRangeIn(data.content);
          var _iterator = _createForOfIteratorHelper(range.getItems()),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              if (item.is('$textProxy')) {
                writer.setAttributes(textAttributes, item);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        });
      });
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'PastePlainText';
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "requires",
    get: function get() {
      return [ClipboardPipeline];
    }
  }]);
  return PastePlainText;
}(Plugin);
/**
 * Returns true if specified `documentFragment` represents a plain text.
 */
export { PastePlainText as default };
function isPlainTextFragment(documentFragment, schema) {
  if (documentFragment.childCount > 1) {
    return false;
  }
  var child = documentFragment.getChild(0);
  if (schema.isObject(child)) {
    return false;
  }
  return Array.from(child.getAttributeKeys()).length == 0;
}